import { parseColorHexRGB } from '@microsoft/fast-colors';
import { getWebRGBA } from '../../_common';
/**
 * @internal
 */
const rapidDialogActiveIconBGColor = parseColorHexRGB('#121212');
const dialogActiveIconBGAlpha = 1;
export const defaultDialogActiveBGColor = getWebRGBA(rapidDialogActiveIconBGColor, dialogActiveIconBGAlpha);
